// mandat-interceptor.ts
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';

// Optional per-request override (null means "don’t force")
export const MANDAT_OVERRIDE = new HttpContextToken<string | null>(() => null);

// Tiny validator for GUID or int
function isValidMandatId(v: string | null | undefined): v is string {
  if (!v) return false;
  const s = v.trim();
  const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  const intRegex = /^\d+$/;
  return guidRegex.test(s) || intRegex.test(s);
}

export const tenantInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {

  // 1) Highest priority: explicit override via HttpContext
  const overrideId = req.context.get(MANDAT_OVERRIDE);

  // 2) Normal “selected mandat” (may be null for GlobalAdmin)
  const selectedId = localStorage.getItem('currentMandatId');

  // 3) Try to infer from the request itself (works for GA screens):
  //    - Query params: mandatId / MandatId
  //    - Body: MandatId / mandatId (POST/PUT/PATCH)
  let inferred: string | null = null;

  // params
  inferred = req.params.get('mandatId') ?? req.params.get('MandatId') ?? null;

  // body (only if still not found & body is object-like)
  if (!inferred && req.body && typeof req.body === 'object') {
    const anyBody = req.body as any;
    inferred = anyBody?.MandatId ?? anyBody?.mandatId ?? null;
  }

  // Final pick in priority order
  const candidate =
    (overrideId && isValidMandatId(overrideId)) ? overrideId :
      (selectedId && isValidMandatId(selectedId)) ? selectedId :
        (isValidMandatId(inferred)) ? inferred : null;

  const newReq = candidate
    ? req.clone({ headers: req.headers.set('X-Mandat-ID', candidate) })
    : req;

  return next(newReq);
};
